import { mdiAccountReactivate, mdiAccountReactivateOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import { IconProps } from '.'
import { palette } from '../styles/colors'

interface IAutoPlayIconProps extends IconProps {
    active?: boolean
    filled?: boolean
    fullWindow: boolean
}

const AutoPlayIcon = memo((props: IAutoPlayIconProps) => {
    const {
        active,
        color,
        filled,
        fullWindow,
        size = 1,
        title,
        ...other
    } = props
    return (
        <Icon
            data-testid="IconButton__AutoPlayButton"
            path={filled ? mdiAccountReactivate : mdiAccountReactivateOutline}
            title={title}
            size={size}
            color={
                color ??
                (active ? palette.buttonOutlinedText : palette.contrastIcons)
            }
            {...other}
        />
    )
})

export default AutoPlayIcon
